import { isEmpty } from 'lodash';
import { TableBodyCellColumnCenter } from '../style/table.styled';
import moment from 'moment';
import { DATE_FORMAT, DATE_FORMAT_WITH_TIME } from '../common';
import { Display } from '../style/common.styled';
import Tag from '../../components/lozenge/tags';

export const EmailLogHeader = ({ actions }: { actions?: any }) => {
  return actions || [];
};
// export const EmailLogHeader = [

//   {
//     Header: 'Title',
//     accessor: 'title',
//     width: 200,
//   },
//   {
//     Header: 'From',
//     accessor: 'from',
//     sortable: false,
//     //   width: 500,
//   },
//   {
//     Header: 'To',
//     accessor: 'to',
//     sortable: false,
//   },
//   {
//     Header: 'Description',
//     accessor: 'descriptionTitle',
//     sortable: false,
//   },
//   // {
//   //   Header: 'Message',
//   //   accessor: 'message',
//   // },
//   {
//     Header: 'Notification Medium',
//     accessor: 'notificationMedium',
//   },
//   {
//     Header: 'Notification Type',
//     accessor: 'notificationType',
//   },
//   {
//     Header: 'Email Status',
//     accessor: 'isSent',
//     center: true,
//     width: 150,
//     Cell: ({ row }: any) => {
//       return (
//         <Display>
//           <Tag
//             variant={row.original.isSent === true ? 'success' : 'info'}
//             title={`${String(row.original.isSent === true ? 'Sent' : 'Not Sent' ?? '')}`}
//           />
//         </Display>
//       );
//     },
//   },
//   {
//     Header: 'CreationTime',
//     accessor: 'creationTime',
//     Cell: ({ row }: any) => {
//       return (
//         <TableBodyCellColumnCenter>
//           {!isEmpty(row.original.creationTime)
//             ? moment(row.original.creationTime).format(DATE_FORMAT_WITH_TIME)
//             : '-'}
//         </TableBodyCellColumnCenter>
//       );
//     },
//   },
// ];
